module.exports = __webpack_public_path__ + "img/branch-particle-19.1e4aac82.png";